import { Board, BoardInstruction, BoardParticipant } from 'types';
import { BoardDelegationRoles, BoardInstructionTypes } from 'types/Board';

import { SELECCIONAR_SOCIO } from 'constants/defaultConstants';
import { boardDelegationRoles } from '../constants/boardDelegation';
import { isRepresentingOtherParticipant } from './delegationEligibility';

export type GetParticipantDelegationDataProps = {
  board: Board;
  hasInstructions: boolean;
  instructions: BoardInstruction[];
  instructionType: BoardInstructionTypes;
  partnerId: string;
  selectedPartner: string;
  selectedRole: BoardDelegationRoles;
};

export const getParticipantDelegationData = ({
  board,
  hasInstructions,
  instructions,
  instructionType,
  partnerId,
  selectedPartner: selectedMember,
  selectedRole,
}: GetParticipantDelegationDataProps): BoardParticipant | null => {
  if (!board.participants.length || selectedMember === SELECCIONAR_SOCIO) {
    return null;
  }

  const currentParticipant = board.participants.find(
    (p) => p.member === partnerId
  );

  if (!currentParticipant) {
    return null;
  }

  if (
    isRepresentingOtherParticipant(
      currentParticipant.member,
      board.participants
    )
  ) {
    return null;
  }

  const selectedRepresentative = board.participants.find(
    (p) => p.member === selectedMember
  );

  if (
    !selectedRepresentative &&
    selectedRole === boardDelegationRoles.PARTNER
  ) {
    return null;
  }

  if (
    selectedRole === boardDelegationRoles.PARTNER &&
    (selectedRepresentative?.isRepresented ||
      (selectedRepresentative?.votes?.length || 0) > 0)
  ) {
    return null;
  }

  if (
    currentParticipant.hasDelegated &&
    currentParticipant.representative &&
    currentParticipant.representative !== selectedMember
  ) {
    return null;
  }

  if (selectedRole === boardDelegationRoles.PARTNER) {
    if (selectedRepresentative?.assists) {
      currentParticipant.assists = true;
      currentParticipant.isAbsent = false;
    } else if (selectedRepresentative?.isAbsent) {
      currentParticipant.assists = false;
      currentParticipant.isAbsent = true;
    }
  }

  if (selectedRole === boardDelegationRoles.PARTNER_REPRESENTANT) {
    currentParticipant.assists = true;
    currentParticipant.isAbsent = false;
  }

  // hasDelegated becomes true once the delegation document is signed.
  currentParticipant.hasDelegated = false;
  currentParticipant.isRepresented = true;
  currentParticipant.representative = selectedMember;
  currentParticipant.hasPartnerRepresentant = !!(
    selectedRole === boardDelegationRoles.PARTNER_REPRESENTANT
  );

  const newInstructions =
    instructionType === BoardInstructionTypes.POINT_BY_POINT
      ? instructions
      : [];

  currentParticipant.delegationVote = hasInstructions
    ? { instructionType, instructions: newInstructions }
    : null;

  return currentParticipant;
};
